import React from 'react';
import { useTranslation } from 'react-i18next';
import Form from '../jo-components/misc/form/form';
import Button from '../jo-components/ui/button/button';
import { generate_use_form_schema } from '../../steps/formStep';
import useForm from '../../utils/useForm';
import { ErrorMessage } from '../jo-components/misc/message/message';
import Message from '../jo-components/misc/message/message';


export default function FormStep({ config = {}, onSubmit = () => {}, isSubmitting = false, isGoingBack = false, step = {}}) {
    const { t } = useTranslation();
    const { form_buyer } = config.waiting_list_form.buyer;
    const { errors: formErrorsBuyerBackend } = form_buyer;
    const title = config.waiting_list_form.header.title;
    const subtitle = config.waiting_list_form.header.subtitle;
    const informationTitle = config.waiting_list_form.message.title;
    const informationDescription = config.waiting_list_form.message.subtitle;

    const [displayErrorsFrontendMessage, setDisplayErrorsFrontendMessage] = React.useState(false);
    let buyerSchema = React.useRef(generate_use_form_schema(form_buyer.fields));

    const [form, setFormValue, setFormObject, , formBuyerErrors, onValidateBuyer, onChangeErrors] = useForm(buyerSchema.current, {
        validateOnChange: false,
        clearOnChange: true,
        onChange: () => {}
    });

    const isBuyerInvalid = React.useMemo(() => {
        return Object.keys(formBuyerErrors).length > 0;
    }, [formBuyerErrors]);

    const isDisabledSubmit = React.useMemo(() => {
        return isBuyerInvalid || isGoingBack;
    }, [isBuyerInvalid, isGoingBack]);

    const _onSubmit = React.useCallback(() => {
        if (isDisabledSubmit) {
            return;
        }
        let { valid } = onValidateBuyer()
        let validAttendees = true;

        if (!valid || !validAttendees) {
            setDisplayErrorsFrontendMessage(true);
            return;
        }
        setDisplayErrorsFrontendMessage(false);
        onSubmit({
            data: {
                buyer: form,
                attendees: {}
            }
        });
    },[form, isDisabledSubmit, onValidateBuyer]);

    React.useEffect(() => {
        if (Object.keys(formErrorsBuyerBackend).length) {
            onChangeErrors({...formErrorsBuyerBackend});
        }
    },[formErrorsBuyerBackend]);

    return (
        <>
            {displayErrorsFrontendMessage && <ErrorMessage config={{
                error_messages: {
                    title: t('widget.front_error_message.title'),
                    body: t('widget.front_error_message.description')
                }
            }}/>}
            <div className='neo-form-step'>
                <h1 className='neo-form-step-title'>{title}</h1>
                <h2 className='neo-form-step-subtitle'>{subtitle}</h2>
                <Message type='info' title={informationTitle} description={informationDescription}/>
                <Form form={form} setFormValue={setFormValue} setFormObject={setFormObject} fields={form_buyer.fields} formIndex='buyer' formErrors={formBuyerErrors}/>
                <div className='neo-cta-container'>
                    <Button type='primary' className='neo-cta-next' isLoading={isSubmitting} onClick={_onSubmit} label={t('widget.resale.tickets.cta-next')} disabled={isDisabledSubmit}/>
                </div>
            </div>
        </>
    )
}